import { render, staticRenderFns } from "./showCourse.vue?vue&type=template&id=2c5afb70&scoped=true"
import script from "./showCourse.vue?vue&type=script&lang=ts"
export * from "./showCourse.vue?vue&type=script&lang=ts"
import style0 from "./showCourse.vue?vue&type=style&index=0&id=2c5afb70&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5afb70",
  null
  
)

export default component.exports